module.exports = __webpack_public_path__ + "media/images/pic01-95275da2bfcde560cda1de021e15cdf2.jpg";